
<div>
    <div v-if = "header">
        <div class="navigation-header pr-2">
            <div class = "navigation-col-header remove-button pl-4">
                <v-icon >mdi-trash-can-outline</v-icon>
            </div>
            <div class = "navigation-col-header elevator">
                {{ $t('inc.unit.elevatorNo') }}
            </div>
        </div>
    </div>

    <v-hover
        v-if   = "!header"
        v-slot = "{ hover }"
    >
        <div
            v-if="unit"
            class="navigation-entry"
            :class ="border2"
        >
            <div
                class="remove-button"
                :class = "background(hover)"
            >
                <a @click="onRemove">
                    <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                </a>
            </div>
            <div
                class  = "elevator"
                :class = "background(hover)"
            >
                {{ unit.fabricNo }}
            </div>
            <div
                class  = "assessment"
                :class = "background(hover)"
            >
                {{ assessment && assessment.type ? assessment.type.name : '---' }}
            </div>
            <div
                class  = "date"
                :class = "background(hover)"
            >
                {{ assessment ? dateAsString (assessment.dateAssessment) : '---' }}

            </div>
            <div
                class  = "pr-2 amount"
                :class = "background(hover)"
            >
                {{ amount }}
            </div>
        </div>
    </v-hover>
</div>
